import { Link } from "react-router-dom";
import { Heart, Music, BarChart3, Sparkles } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-20">
      <div className="label-eyebrow mb-3">About</div>
      <h1 className="font-serif-display text-5xl lg:text-6xl text-white leading-tight">
        Where <span className="italic text-[#D4AF37]">worship</span> meets <span className="italic text-[#D4AF37]">analytics</span>.
      </h1>
      <p className="text-lg text-neutral-300 mt-8 leading-relaxed">
        HOH_Vibes is a creative brand producing inspirational gospel music, faith-based content and professional Power BI templates. We exist to serve worshippers and analysts alike — equipping ministries and businesses with premium, purpose-driven digital assets.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
        {[
          { icon: Music, title: "Original Music", text: "Studio-quality gospel & worship recordings released as MP3 and lossless WAV." },
          { icon: BarChart3, title: "Premium Templates", text: "PBIX dashboards with documentation, sample data and walkthroughs." },
          { icon: Heart, title: "Faith-Centered", text: "Every product is crafted with prayer, excellence and purpose." },
        ].map((b, i) => {
          const Icon = b.icon;
          return (
            <div key={i} className="luxury-card rounded-xl p-8">
              <Icon size={28} className="text-[#D4AF37]" />
              <h3 className="font-serif-display text-2xl text-white mt-4">{b.title}</h3>
              <p className="text-neutral-400 mt-2 leading-relaxed text-sm">{b.text}</p>
            </div>
          );
        })}
      </div>
      <div className="mt-20 p-10 luxury-card rounded-xl flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <div className="label-eyebrow">Get Started</div>
          <h3 className="font-serif-display text-3xl text-white mt-2">Discover a sound or dashboard that speaks to your purpose.</h3>
        </div>
        <div className="flex gap-3">
          <Link to="/music" className="btn-gold px-5 py-3 rounded text-xs tracking-widest uppercase">Shop Music</Link>
          <Link to="/templates" className="btn-ghost-gold px-5 py-3 rounded text-xs tracking-widest uppercase">Shop Templates</Link>
        </div>
      </div>
    </div>
  );
}
